// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InAppPromotionModel", {
    enumerable: true,
    get: function() {
        return InAppPromotionModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const InAppPromotionModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    description: _zod.z.string(),
    type: _zod.z.string(),
    bannerCopy: _zod.z.string(),
    hyperlink: _zod.z.string(),
    bannerEnabled: _zod.z.boolean().optional(),
    __v: _zod.z.number()
});
